import { CarePlanQuestionnaireNode as CarePlanQuestionnaireSchema } from '@seen/core/tiptap/schema'
import { ReactNodeViewRenderer } from '@tiptap/react'
import { CarePlanQuestionnaireNodeView } from '#src/components/rich-text-editor/CarePlanQuestionnaireNode/CarePlanQuestionnaireNodeView.tsx'

// Embeds a care-plan demographic questionnaire (Evaluation, Physical
// Functioning) in the care plan Description as an editable structured block.
// The node stores only the questionnaire's canonical URL — never a resource id
// — so the same template HTML serves every participant; the NodeView resolves
// the participant's (or snapshot's) response from context at render time.
export const CarePlanQuestionnaireNode = CarePlanQuestionnaireSchema.extend({
  addNodeView() {
    return ReactNodeViewRenderer(CarePlanQuestionnaireNodeView, {
      className: 'group',
    })
  },
})
